"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAsyncWriteStream = void 0;
const getLogger_1 = require("./getLogger");
const logger = (0, getLogger_1.getLogger)('asyncWriteStream');
function createAsyncWriteStream(stream, options) {
    const writable = new stream.Writable({
        objectMode: true,
    });
    writable._write = async (chunk, encoding, callback) => {
        try {
            await options.processItem(chunk);
            callback(null);
        }
        catch (err) {
            callback(err);
        }
    };
    // writable._final = async callback => {
    //   callback();
    // };
    return writable;
}
exports.createAsyncWriteStream = createAsyncWriteStream;
